import { Fragment } from "react";
import { FieldColumnName } from "../../fields/FieldColumnName";
import { PanelProps } from "../ModalCreateColumn";

export const PanelCreateColumnRoiFrame = ({
  autoFocus = true,
  isDefinitionEditable = true,
  fields,
  onFieldChange,
}: PanelProps) => {
  return (
    <Fragment>
      <FieldColumnName
        autoFocus={autoFocus}
        value={fields.name.value}
        onChange={(field) => {
          onFieldChange("name", {
            value: field.value,
            isValid: field.isValid,
            isDirty: true,
          });
        }}
      />
    </Fragment>
  );
};
